import { jsxs as c, jsx as i } from "react/jsx-runtime";
import { QUERIES as x } from "@fcamna/shared-component-foundations";
import a, { css as m } from "styled-components";
import "react";
import { u as $ } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { h as y } from "./hTag-27bb1617.mjs";
const l = a.div`
  ${({ theme: { componentStyles: e } }) => m(e)};
  display: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.FeatureTextContainer.display;
}};
  flex-direction: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.FeatureTextContainer.flexDirection;
}};
  row-gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.FeatureTextContainer.rowGap;
}};
  justify-content: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.FeatureTextContainer.justifyContent;
}};
  padding: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.FeatureTextContainer.padding;
}};

  @media ${x.laptopAndUp} {
    padding: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.FeatureTextContainer.mobilePadding;
}};
  }
`, u = a.div`
  display: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.FeatureTextWrapper.display;
}};
  flex-direction: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.FeatureTextWrapper.flexDirection;
}};
  ${({ theme: e, $showButtonGroup: t, $alignment: n }) => `
    gap: ${!t && n === "center" ? e.components.featureText.FeatureTextWrapper.gap.center : e.components.featureText.FeatureTextWrapper.gap.default};
    align-items: ${n === "center" ? e.components.featureText.FeatureTextWrapper.alignItems.center : e.components.featureText.FeatureTextWrapper.alignItems.default};
    text-align: ${n === "center" ? e.components.featureText.FeatureTextWrapper.textAlign.center : e.components.featureText.FeatureTextWrapper.textAlign.default};
  `}
`, F = () => `
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, f = a(y)`
  color: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.TitleWrapper.color;
}};
  ${({ theme: e, $titleSize: t }) => `
    font-family: ${t === "large" ? e == null ? void 0 : e.components.featureText.TitleWrapper.large.fontFamily : t === "xxLarge" ? e == null ? void 0 : e.components.featureText.TitleWrapper.xxLarge.fontFamily : e == null ? void 0 : e.components.featureText.TitleWrapper.extraLarge.fontFamily};
    font-weight: ${t === "large" ? e == null ? void 0 : e.components.featureText.TitleWrapper.large.fontWeight : t === "xxLarge" ? e == null ? void 0 : e.components.featureText.TitleWrapper.xxLarge.fontWeight : e == null ? void 0 : e.components.featureText.TitleWrapper.extraLarge.fontWeight};
    font-size: ${t === "large" ? e == null ? void 0 : e.components.featureText.TitleWrapper.large.fontSize : t === "xxLarge" ? e == null ? void 0 : e.components.featureText.TitleWrapper.xxLarge.fontSize : e == null ? void 0 : e.components.featureText.TitleWrapper.extraLarge.fontSize};
    line-height: ${t === "large" ? e == null ? void 0 : e.components.featureText.TitleWrapper.large.lineHeight : t === "xxLarge" ? e == null ? void 0 : e.components.featureText.TitleWrapper.xxLarge.lineHeight : e == null ? void 0 : e.components.featureText.TitleWrapper.extraLarge.lineHeight};
  `};
`, T = a.div`
  ${F()}
  color: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.DescriptionWrapper.color;
}};
  font-family: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.DescriptionWrapper.fontFamily;
}};
  font-size: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.DescriptionWrapper.fontSize;
}};
  font-style: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.DescriptionWrapper.fontStyle;
}};
  font-weight: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.DescriptionWrapper.fontWeight;
}};
  line-height: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.DescriptionWrapper.lineHeight;
}};
`, g = a.div`
  display: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.ActionButtonWrapper.display;
}};
  gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.ActionButtonWrapper.gap;
}};
  flex-direction: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.ActionButtonWrapper.flexDirection;
}};

  @media ${x.tabletAndUp} {
    flex-direction: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.ActionButtonWrapper.mobileStyles.flexDirection;
}};
    gap: ${(e) => {
  var t;
  return (t = e == null ? void 0 : e.theme) == null ? void 0 : t.components.featureText.ActionButtonWrapper.mobileStyles.gap;
}};
    justify-content: ${({ $alignment: e, theme: t }) => e === "center" ? t.components.featureText.ActionButtonWrapper.mobileStyles.justifyContent.center : t.components.featureText.ActionButtonWrapper.mobileStyles.justifyContent.default};
  }
`, r = ({
  actionButtons: e,
  titleProp: t = { title: "Title", headingLevel: "h1", size: "large" },
  description: n,
  alignment: o = "left",
  ...W
}) => {
  const d = $({ label: "Feature Text" });
  return /* @__PURE__ */ c(
    l,
    {
      ...W,
      ...d,
      children: [
        /* @__PURE__ */ c(
          u,
          {
            $showButtonGroup: !!e,
            $alignment: o,
            children: [
              /* @__PURE__ */ i(
                f,
                {
                  as: t.headingLevel,
                  $titleSize: t.size,
                  children: t.title
                }
              ),
              n && /* @__PURE__ */ i(T, { children: n })
            ]
          }
        ),
        e && /* @__PURE__ */ i(g, { $alignment: o, children: e })
      ]
    }
  );
};
r.Container = l;
r.Wrapper = u;
r.TitleWrapper = f;
r.ActionButtonWrapper = g;
r.DescriptionWrapper = T;
export {
  r as FeatureText
};
